import { H2 } from '@student-coin/coinpaper-components';
import styled from 'styled-components';

export const StyledH2 = styled(H2)`
  &:hover {
    text-decoration: underline;
  }
`;

export const ArticleCardContainer = styled.div`
  min-width: 120px;
  min-height: 70px;
  img {
    object-fit: cover;
    object-position: top;
  }
`;
